module.exports = __webpack_public_path__ + "img/about_mission.2a90019c.png";